import { useMediaQuery } from '@mui/material';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
export function ScrollToTop() {
  var _useLocation = useLocation(),
      pathname = _useLocation.pathname;

  var isMobile = useMediaQuery(function (theme) {
    return "(max-width:".concat(theme.breakpoints.values.md, "px)");
  });
  useEffect(function () {
    if (isMobile) return;
    window.scrollTo(0, 0);
  }, [pathname, isMobile]);
  return null;
}